// Profil sayfası (/profile)
const profilePage = {
  loadError: 'Profil bilgileriniz yüklenemedi. Sayfayı yenilemeyi deneyin.',
  common: {
    cancel: 'Vazgeç',
    save: 'Kaydet',
    saving: 'Kaydediliyor...',
    previous: 'Önceki',
    next: 'Sonraki',
    pages: 'Sayfalar',
  },
  nav: {
    label: 'Profil bölümleri',
    groups: {
      'takvim-ajanda': 'Takvim',
      dosyalar: 'Dosyalar',
      projelerim: 'Projelerim',
      'izin-yonetimi': 'İzin',
      'masraf-yonetimi': 'Masraf',
      'iletisim-bildirim': 'İletişim',
      'dilekce-yonetimi': 'Dilekçe',
      'cv-yonetimi': 'CV / GCP / IATA',
      kargolarim: 'Kargolarım',
    },
    tabs: {
      takvim: 'Takvimim',
      ajandam: 'Ajandam',
      'izin-talep': 'İzin Talep Et',
      'izin-taleplerim': 'İzin Taleplerim',
      'masraf-talep': 'Masraf Talep Et',
      'masraf-takip': 'Masraf Takip',
      'masraf-talepleri': 'Masraf Talepleri',
      mesajlar: 'Mesajlar',
      bildirimler: 'Bildirimler',
      'sistem-hata-bildirimleri': 'Hata Bildir',
      sikayetlerim: 'Dilekçelerim',
      'gelen-sikayetler': 'Gelen Dilekçeler',
      'cv-tr': 'Türkçe CV',
      'cv-en': 'İngilizce CV',
      gcp: 'GCP',
      iata: 'IATA',
    },
  },
  sections: {
    expenseApprovals: {
      title: 'Masraf Talepleri',
      description: 'Çalışanların masraf taleplerini buradan inceleyip onaylayabilir ya da reddedebilirsiniz.',
    },
    'cv-tr': {
      title: 'Türkçe CV',
      description: 'Güncel Türkçe özgeçmişinizi yükleyin. Proje başvurularında ve denetimlerde bu dosya kullanılır.',
    },
    'cv-en': {
      title: 'İngilizce CV',
      description: 'Uluslararası sponsorlar için İngilizce özgeçmişinizi buradan yükleyebilirsiniz.',
    },
    gcp: {
      title: 'GCP Sertifikası',
      description: 'İyi Klinik Uygulamalar (GCP) sertifikanızı yükleyin; geçerlilik tarihi yaklaştığında yenilemeyi unutmayın.',
    },
    iata: {
      title: 'IATA Sertifikaları',
      description: 'Numune gönderimi için gereken IATA sertifikalarınızı yükleyin. Birden fazla dosya ekleyebilirsiniz.',
    },
    cargo: {
      title: 'Kargolarım',
      description: 'Size gelen ve sizin gönderdiğiniz kargoları buradan takip edebilirsiniz.',
    },
  },
  hero: {
    label: 'Profil kartı',
    noName: 'Profilim',
    photoAlt: 'Profil fotoğrafı',
    changePhoto: 'Fotoğrafı değiştir',
    photoSaved: 'Profil fotoğrafınız güncellendi.',
    photoError: 'Profil fotoğrafı yüklenirken bir hata oluştu.',
    changePassword: 'Şifremi Değiştir',
    stats: {
      projects: 'Aktif proje',
      sops: 'SOP okundu',
      messages: 'Okunmamış mesaj',
    },
    contacts: {
      title: 'İletişim bilgilerim',
      phone: 'Telefon',
      emergency: 'Acil durum telefonu',
      email: 'E-posta',
      home: 'Ev adresi',
      work: 'İş adresi',
      primary: 'Ana adres',
      none: 'Kayıtlı değil',
      notAdded: 'Henüz eklenmedi',
      edit: 'Düzenle',
      add: 'Ekle',
    },
    completion: {
      title: 'Profil tamamlama',
      complete: 'Profiliniz tamam',
      seeMissing: 'Eksikleri görün',
      explain: 'Kişisel bilgiler, fotoğraf ve size atanan eğitimlerden hesaplanır.',
      rows: {
        personal: 'Kişisel bilgiler',
        photo: 'Profil fotoğrafı',
        education: 'SOP ve eğitimler',
      },
      personalDetail: '{{filled}}/{{total}} alan dolu',
      educationDetail: '{{completed}}/{{total}} tamamlandı',
      noAssignments: 'Size atanmış SOP veya eğitim yok',
      done: 'Tamamlandı',
      missing: 'Eksik',
      todo: 'Tamamlamak için',
      suggestions: {
        photo: 'Profil fotoğrafı yükleyin',
        emergencyPhone: 'Acil durum telefonu ekleyin',
        address: 'Ev adresinizi ekleyin',
        education: 'Bekleyen SOP ve eğitimlere gidin',
      },
      othersMissing: 'Ad, rol, e-posta veya telefon gibi diğer eksik bilgiler için yöneticinize başvurun.',
    },
  },
  photo: {
    title: 'Profil Fotoğrafı',
    subtitle: 'Kaydetmeden önce nasıl görüneceğine bakın',
    onProfile: 'Profilde',
    onCard: 'Kartlarda',
    inMenu: 'Menüde',
    another: 'Başka fotoğraf seç',
    save: 'Fotoğrafı Kaydet',
    saving: 'Kaydediliyor...',
    notImage: 'Seçtiğiniz dosya bir fotoğraf değil. Lütfen JPG veya PNG bir görsel seçin.',
    tooLarge: 'Fotoğraf çok büyük (en fazla 15 MB). Lütfen daha küçük bir dosya seçin.',
    noPreview: 'Bu fotoğraf tarayıcıda önizlenemiyor; yine de kaydedebilirsiniz.',
    tips: 'Yüzünüzün net göründüğü, iyi ışıklı bir fotoğraf seçin. Fotoğraf kaydedilirken uygun boyuta küçültülür.',
  },
  dialogs: {
    userNotFound: 'Kullanıcı bilginiz bulunamadı.',
    address: {
      title: 'Adres Bilgilerim',
      subtitle: 'Ev ve iş adresiniz',
      home: 'Ev adresi',
      homePlaceholder: 'Mahalle, sokak, no, ilçe / il',
      homeRequired: 'Ev adresi boş olamaz',
      work: 'İş adresi',
      workPlaceholder: 'Çalıştığınız kurumun adresi (varsa)',
      workHint: 'İsteğe bağlı',
      primary: 'Ana adresim',
      primaryHint: 'Seçtiğiniz adres, Çalışan Yönetimi listelerinde ve çalışan kartınızda "Ana Adres" olarak görünür.',
      primaryHomeOnly: 'İş adresi girilmediği için ana adresiniz ev adresinizdir.',
      saved: 'Adres bilgileriniz güncellendi.',
      saveError: 'Adres güncellenirken bir hata oluştu.',
    },
    phone: {
      title: 'Acil Durum Telefonu',
      subtitle: 'Size ulaşılamadığında aranacak numara',
      number: 'Telefon numarası',
      placeholder: '05xx xxx xx xx',
      hint: 'Bir yakınınızın numarası olabilir. Yalnızca acil durumlarda kullanılır.',
      saved: 'Acil durum telefonunuz güncellendi.',
      saveError: 'Acil durum telefonu güncellenirken bir hata oluştu.',
    },
    password: {
      title: 'Şifremi Değiştir',
      subtitle: 'Güvenliğiniz için mevcut şifrenizi de girin',
      current: 'Mevcut şifre',
      new: 'Yeni şifre',
      confirm: 'Yeni şifre (tekrar)',
      show: 'Şifreleri göster',
      hide: 'Şifreleri gizle',
      ruleLength: 'En az 6 karakter',
      ruleMatch: 'İki yeni şifre aynı',
      submit: 'Şifreyi Değiştir',
      saved: 'Şifreniz değiştirildi.',
      errors: {
        required: 'Lütfen tüm alanları doldurun.',
        mismatch: 'Yeni şifreler eşleşmiyor.',
        length: 'Şifre en az 6 karakter olmalıdır.',
        wrong: 'Mevcut şifreniz yanlış.',
        failed: 'Şifre değiştirilemedi. Lütfen tekrar deneyin.',
      },
    },
  },
  calendar: {
    title: 'Takvimim',
    description: 'Vizitleriniz, işleriniz ve onaylı izinleriniz aylık olarak burada. Bir güne dokunun; o günün tüm kayıtları listelenir. Bir kayda dokunarak ayrıntısını açabilirsiniz.',
    loading: 'Takvim yükleniyor...',
    gridLabel: 'Aylık takvim',
    prevMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    today: 'Bugün',
    viewLabel: 'Görünüm',
    views: {
      month: 'Ay',
      list: 'Liste',
    },
    actions: {
      addVisit: 'Vizit Ekle',
      addJob: 'İş Ekle',
      excel: 'Excel',
      excelHint: 'Bu ayın vizitlerini Excel olarak indir',
    },
    excelEmpty: 'Bu ay için indirilecek vizit bulunamadı.',
    summary: {
      label: 'Bu ayın özeti',
      total: 'vizit',
      planned: 'planlanan',
      inProgress: 'devam eden',
      overdue: 'tamamlanmadı',
      completed: 'tamamlandı',
      screenFail: 'screen fail',
      jobs: 'iş',
    },
    entryCount_one: '{{count}} kayıt',
    entryCount_other: '{{count}} kayıt',
    noEntriesShort: 'kayıt yok',
    openWindows_one: '{{count}} açık pencere',
    openWindows_other: '{{count}} açık pencere',
    agenda: {
      planned: 'Bu günün planı',
      nothingPlanned: 'Bu güne planlanmış vizit veya iş yok.',
      openWindows_one: 'Penceresi açık vizit ({{count}})',
      openWindows_other: 'Penceresi açık vizitler ({{count}})',
      openWindowsHint: 'Vizit günü başka gün ama bu gün de yapılabilir.',
      showAll: 'Tümünü göster ({{count}})',
      showLess: 'Daha az göster',
    },
    options: {
      windows: 'Pencereler',
      windowsHint: 'Vizit pencerelerini çubuk olarak göster. Kapatınca her vizit yalnızca vizit gününde görünür.',
      hideCompleted: 'Tamamlananları gizle',
      hideCompletedHint: 'Tamamlanan vizitleri ve işleri takvimden gizler.',
    },
    projectFilter: {
      button: 'Projeler',
      someHidden: 'Projeler ({{shown}}/{{total}})',
      title: 'Gösterilen projeler',
      showAll: 'Tümünü göster',
    },
    help: {
      button: 'Nasıl okunur?',
      title: 'Takvim nasıl okunur?',
      bar: 'Her vizit, penceresi boyunca tek bir çubuktur. Açık renkli kısım vizitin yapılabileceği pencere, koyu kısım planlanan vizit günüdür.',
      done: 'Tamamlanan vizit yeşildir; yeşil tik, vizitin yapıldığı günü gösterir.',
      stripe: 'Çubuğun solundaki renkli şerit projeyi gösterir. Kesik çizgili çubuklar sizin işlerinizdir. Bir çubuğa dokunarak ayrıntısını açabilirsiniz.',
      tips: 'İpucu: Bir güne dokunduğunuzda o günün planı ve penceresi açık vizitler ayrı ayrı listelenir. Takvim kalabalıksa "Pencereler"i kapatın ya da "Tamamlananları gizle"yi açın.',
    },
    more_one: '+{{count}} daha',
    more_other: '+{{count}} daha',
    emptyDay: 'Bu gün için kayıt yok.',
    emptyMonth: 'Bu ay takviminiz boş.',
    emptyMonthHint: 'Yeni vizit veya iş eklediğinizde burada gün gün listelenir.',
    projectFallback: 'Proje',
    noPatient: 'Hasta ID yok',
    screenFail: 'Screen fail',
    visitOrdinal: '{{n}}. Visit',
    dayLabel: {
      first: 'Vizit günü',
      after: '+{{n}}. gün',
      before: '{{n}}. gün',
    },
    jobLabel: 'İş',
    jobDay: '{{n}}. gün',
    jobStatus: {
      done: 'Tamamlandı',
      ongoing: 'Devam ediyor',
    },
    pendingDates: 'Eksik tarih: {{items}}',
    pending: {
      ecrf: 'e-CRF',
      sourceDoc: 'Kaynak doküman',
      signature: 'e-CRF imzası',
    },
    status: {
      screenFail: 'Screen fail',
      notCompleted: 'Tamamlanmadı',
      ongoing: 'Devam ediyor',
      completedNoDate: 'Tamamlandı · Tamamlanma tarihi kayıtlı değil',
      completedThisDay: 'Bu gün tamamlandı: {{date}}',
      completedWindowClosed: 'Tamamlandı: {{date}} · Pencere kapandı',
      missingSuffix: ' · Eksik: {{items}}',
      completedOn: 'Tamamlandı: {{date}}',
    },
    tooltip: {
      visitDay: 'Vizit günü',
      window: 'Pencere',
      project: 'Proje',
      patient: 'Hasta ID',
      visit: 'Vizit',
      day: 'Gün',
      status: 'Durum',
      time: 'Saat',
    },
    visitTypes: {
      hastane: 'Hastane Vizit',
      home: 'Home Vizit',
      telefon: 'Telefon Vizit',
      unplanning: 'Unplanning Vizit',
      handover: 'Handover Vizit',
    },
    onLeave: 'İzinli',
    leaveBanner: 'Bu gün izinlisiniz',
    leaveDays_one: '{{count}} gün',
    leaveDays_other: '{{count}} gün',
    legend: {
      title: 'Renkler ve projeler',
      planned: 'Planlanan',
      inProgress: 'Devam ediyor',
      overdue: 'Tamamlanmadı',
      completedDay: 'Tamamlandığı gün',
      completed: 'Tamamlandı',
      windowClosed: 'Pencere kapandı',
      screenFail: 'Screen fail',
      job: 'İş',
      leave: 'İzinli gün',
      note: 'Koyu ve çerçeveli olan, vizitin asıl günüdür; açık renkli olanlar pencerenin diğer günleridir. Çipin solundaki renkli şerit projeyi gösterir.',
      projects: 'Bu ayın projeleri (dokunarak gizleyip gösterebilirsiniz)',
      hideProject: 'Bu projenin vizitlerini gizle',
      showProject: 'Bu projenin vizitlerini göster',
      hiddenCount_one: '{{count}} proje gizli',
      hiddenCount_other: '{{count}} proje gizli',
    },
    visitForm: {
      title: 'Yeni Vizit',
      subtitle: 'Projenizdeki bir hasta için vizit planlayın',
      saving: 'Kaydediliyor...',
      saved_one: 'Vizit eklendi.',
      saved_other: '{{count}} vizit eklendi.',
      sections: {
        who: 'Proje ve hasta',
        when: 'Tarih ve vizit penceresi',
        details: 'Vizit bilgileri',
        options: 'Seçenekler',
      },
      project: 'Proje',
      chooseProject: 'Proje seçin',
      patient: 'Hasta ID',
      patientOptional: 'Hasta seçin (isteğe bağlı)',
      patientHint: 'Yalnızca sizin vizit açtığınız veya eklediğiniz hastalar listelenir.',
      chooseProjectFirst: 'Önce proje seçin',
      patientsLoading: 'Hastalar yükleniyor...',
      noPatients: 'Bu projede size ait hasta yok',
      noPatientsHint: 'Yandaki + ile yeni hasta ekleyebilirsiniz.',
      addPatient: 'Yeni hasta ekle',
      visitDate: 'Vizit tarihi',
      visitDateHint: 'Vizitin planlandığı gün',
      windowStart: 'Pencere başlangıcı',
      windowEnd: 'Pencere bitişi',
      quickWindow: 'Pencereyi hızlı ayarla:',
      sameDay: 'Aynı gün',
      plusMinus: '±{{n}} gün',
      windowSummary: 'Pencere {{before}} gün önce başlar, {{after}} gün sonra biter (toplam {{total}} gün).',
      visitType: 'Vizit tipi',
      choose: 'Seçin',
      visitNumber: 'Kaçıncı vizit',
      visitNumberPlaceholder: 'Örn. 1, 2, 3',
      visitNumberHint: 'Hasta seçildiğinde sıradaki numara önerilir.',
      suggestedNext: 'Bu hastanın bu projedeki sıradaki viziti: {{n}}. İsterseniz değiştirebilirsiniz.',
      suggested: 'Önerilen: {{n}}',
      screenFail: 'Screen fail mi?',
      screenFailNote: 'Screen fail olarak işaretlenen kayıtlar vizit olarak sayılmaz, yapılan iş olarak kaydedilir.',
      info: 'Not',
      infoPlaceholder: 'Vizitle ilgili kısa bir not',
      repeat: 'Tekrar edecek',
      repeatEnd: 'Kapanış viziti tarihi',
      repeatEndHint: 'Tekrarlar bu tarihe kadar oluşturulur.',
      repeatEvery: 'Tekrar aralığı',
      repeatUnit: 'Birim',
      repeatDayHint: 'Gün seçildiğinde, sonraki vizit pencere süresi + bu kadar gün sonra başlar.',
      units: {
        day: 'Gün',
        week: 'Hafta',
        month: 'Ay',
      },
      googleCalendar: 'Google Takvimime de ekle',
      googleHint: 'Kaydettikten sonra Google Takvim yeni sekmede, bilgiler dolu olarak açılır; orada "Kaydet"e basmanız yeterli.',
      errors: {
        dates: 'Lütfen tüm tarih alanlarını doldurun.',
        window: 'Vizit tarihi, pencere başlangıcı ile bitişi arasında olmalı.',
        repeatPeriod: 'Tekrar aralığı 0’dan büyük olmalı.',
        save: 'Vizit eklenirken bir hata oluştu.',
      },
      mirror: {
        created: 'Hibrit proje: vizit unblinded çalışanın takvimine de eklendi.',
        createdNamed: 'Hibrit proje: vizit unblinded çalışanın takvimine de eklendi ({{names}}).',
        skipped: 'Hibrit proje: unblinded çalışanın takviminde bu hasta ve tarih için vizit zaten var.',
        failed: 'Vizitiniz eklendi ancak unblinded çalışanın takvimine düşürülemedi. Lütfen kendisine haber verin.',
      },
    },
    jobForm: {
      title: 'Yeni İş',
      subtitle: 'Takviminize kişisel bir iş ekleyin',
      jobTitle: 'İş başlığı',
      jobTitlePlaceholder: 'Örn. Merkez evrak teslimi',
      startDate: 'Başlangıç tarihi',
      endDate: 'Bitiş tarihi',
      endDateHint: 'Tek günlük işte başlangıçla aynı gün',
      time: 'Saat',
      timeHint: 'İsteğe bağlı; gün içinde sıralamada kullanılır',
      help: 'İşler yalnızca sizin takviminizde görünür. Tamamladığınızda işin üzerine dokunup "Tamamlandı" olarak işaretleyebilirsiniz.',
      added: 'İş takviminize eklendi.',
      addError: 'İş eklenirken bir hata oluştu.',
    },
    jobDetail: {
      title: 'İş ayrıntısı',
      status: 'Durum',
      time: 'Saat',
      startDate: 'Başlangıç',
      endDate: 'Bitiş',
      markDone: 'Tamamlandı olarak işaretle',
      markOpen: 'Tamamlanmadı olarak işaretle',
      markedDone: 'İş tamamlandı olarak işaretlendi.',
      markedOpen: 'İş devam ediyor olarak işaretlendi.',
      updateError: 'İş durumu güncellenirken bir hata oluştu.',
      delete: 'İşi Sil',
      deleteTitle: 'İş silinsin mi?',
      deleteMessage: '"{{title}}" takviminizden silinecek. Bu işlem geri alınamaz.',
      deleted: 'İş silindi.',
      deleteError: 'İş silinirken bir hata oluştu.',
    },
  },
  tutorial: {
    cta: {
      eyebrow: 'Video rehber · {{minutes}} dakika',
      title: 'Takvimi ve vizit formunu adım adım öğrenin',
      text: 'Takvimi okumayı, yeni vizit açmayı ve vizit formunu doldurup tamamlamayı kısa bir videoda, ekran ekran gösteriyoruz.',
      watch: 'Videoyu izle',
      later: 'Daha sonra',
      button: 'Video rehber',
      buttonHint: 'Takvim ve vizit formu nasıl kullanılır? Videoyu izleyin.',
      watched: 'İzlendi',
    },
    player: {
      title: 'Takvim ve Vizit Formu Rehberi',
      subtitle: 'Adım adım video anlatım',
      play: 'Oynat',
      pause: 'Duraklat',
      replay: 'Baştan izle',
      prevChapter: 'Önceki bölüm',
      nextChapter: 'Sonraki bölüm',
      seek: 'Video konumu',
      speed: 'Oynatma hızı',
      captionsOn: 'Altyazıyı gizle',
      captionsOff: 'Altyazıyı göster',
      voiceOn: 'Sesli anlatımı kapat',
      voiceOff: 'Sesli anlatımı aç',
      voiceUnavailable: 'Bu tarayıcıda Türkçe sesli anlatım bulunamadı; altyazılar açık.',
      fullscreen: 'Tam ekran',
      exitFullscreen: 'Tam ekrandan çık',
      chapters: 'Bölümler',
      chapterOf: 'Bölüm {{current}} / {{total}}',
      ended: 'Video bitti',
      endedText: 'Artık takviminizi kullanmaya hazırsınız. Bir bölümü yeniden izlemek için listeden seçebilirsiniz.',
      backToCalendar: 'Takvime dön',
      keyboard: 'Kısayollar: Boşluk oynat / duraklat · ← → 5 saniye',
      demoNote: 'Videodaki proje, hasta ve hekim bilgileri örnektir.',
    },
    chapters: {
      intro: 'Giriş',
      overview: 'Takvime genel bakış',
      reading: 'Takvimi okumak',
      day: 'Bir günün planı',
      addVisit: 'Yeni vizit açmak',
      visitForm: 'Vizit formunu doldurmak',
      tips: 'Unutmayın',
    },
    beats: {
      intro: 'Bu kısa videoda takvimi nasıl kullanacağınızı, yeni bir vizit açmayı ve vizit formunu doldurup tamamlamayı adım adım göreceksiniz.',
      overview: 'Profil sayfasındaki Takvim sekmesi; vizitlerinizi, işlerinizi ve onaylı izinlerinizi aylık olarak tek ekranda gösterir.',
      months: 'Üstteki oklarla aylar arasında gezinirsiniz. Başka bir aya geçtiğinizde beliren Bugün düğmesi sizi hemen bugüne döndürür.',
      summary: 'Hemen alttaki özet, bu ay kaç vizitiniz olduğunu; kaçının planlandığını, devam ettiğini ya da tamamlandığını gösterir.',
      bars: 'Her vizit, yapılabileceği pencere boyunca tek bir çubuktur. Açık renkli kısım pencere, koyu kısım planlanan vizit günüdür. Çubuğun üzerine gelince ayrıntısı görünür.',
      colors: 'Renk, vizitin durumunu anlatır: mavi planlanan, sarı devam eden, kırmızı süresi geçmiş ama tamamlanmamış, yeşil tamamlanmış vizittir. Yeşil tik, vizitin yapıldığı gündür.',
      stripes: 'Çubuğun solundaki renkli şerit vizitin hangi projeye ait olduğunu gösterir. Kesik çizgili çubuklar ise kendi eklediğiniz işlerdir.',
      declutter: 'Takvim kalabalıklaşırsa Pencereler düğmesini kapatın; her vizit yalnızca kendi gününde görünür. Tamamlananları gizle ve Projeler filtresi de ekranı sadeleştirir.',
      day: 'Bir güne dokunduğunuzda o günün ayrıntısı sağdaki panelde açılır.',
      dayLists: 'Üstte o güne planlanan vizit ve işler, altta penceresi açık vizitler listelenir. Bunların vizit günü başka bir gün olsa da o gün de yapılabilirler.',
      addOpen: 'Yeni bir vizit açmak için sağ üstteki Vizit Ekle düğmesine basın. Önce bir gün seçerseniz vizit tarihi o günle dolu gelir.',
      addWho: 'Önce projeyi, ardından hastayı seçin. Listede yalnızca size ait hastalar görünür; yeni bir hasta için yanındaki artı düğmesini kullanın.',
      addWhen: 'Vizit tarihi, seçtiğiniz günle dolu gelir; gerekirse değiştirin. Ardından vizit penceresini belirleyin: hızlı seçeneklerle artı eksi üç gün gibi bir pencereyi tek dokunuşla kurabilirsiniz.',
      addDetails: 'Vizit tipini seçin. Kaçıncı vizit olduğu, hastanın önceki vizitlerine bakılarak sizin için önerilir.',
      addSave: 'Düzenli tekrarlanan vizitler için Tekrar edecek seçeneğini açabilirsiniz. Son olarak Kaydet’e basın; vizit hemen takviminizde belirir.',
      formOpen: 'Vizite gittiğinizde takvimdeki çubuğuna dokunun; Vizit Detayları penceresi açılır.',
      formRail: 'Form adım adım ilerler. Soldaki listede turuncu adımlarda eksik alan vardır, yeşil tik o adımın tamam olduğunu gösterir. İlerleme yüzdesi en üsttedir.',
      formTodo: 'Yapılacaklar adımında yaptığınız kontrolleri işaretleyin. Bu işaretler anında kaydedilir; ayrıca Kaydet’e basmanız gerekmez.',
      formMissing: 'Ziyaret Formu adımında doldurulmamış zorunlu alanlar üstte turuncu etiketlerle listelenir. Bir etikete dokunduğunuzda sizi doğrudan o alana götürür.',
      formFields: 'Vizit tipini, kaynak dokümanı, seyahat tipini, hekimi ve hastaneyi girin. Hastaneyi seçtiğinizde şehir kendiliğinden dolar.',
      formExtras: 'Malzeme kullandıysanız Stok, kargo gönderdiyseniz Kargo Takip, masraf yaptıysanız Harcamalar adımına ekleyin. Bu adımlar isteğe bağlıdır.',
      formEval: 'Son olarak Visit Değerlendirme adımındaki yıldızlı soruları yanıtlayın. Her yanıtla ilerleme artar.',
      formComplete: 'İstediğiniz an Kaydet ile ara kayıt alabilirsiniz. İlerleme yüzde yüze ulaştığında Ziyareti Tamamla’ya basın.',
      formDone: 'Tamamlanan vizit takvimde yeşile döner; yeşil tik vizitin yapıldığı günü gösterir.',
      tipsDeadline: 'Unutmayın: vizit penceresi bittikten sonra viziti tamamlamak için yetmiş iki saatiniz vardır. Bu süre geçince vizit salt okunur olur.',
      tipsEnd: 'Renkleri hatırlamak için Nasıl okunur düğmesine bakabilir, bu videoyu dilediğiniz zaman yeniden izleyebilirsiniz. Kolay gelsin!',
    },
    stage: {
      datePlaceholder: 'gg.aa.yyyy',
      profile: 'Profil',
      jobDocs: 'Merkez evrak teslimi',
      jobTraining: 'Eğitim',
      doctor: 'Dr. Ayşe Kaya',
      hospital: 'Ankara Şehir Hastanesi',
      city: 'Ankara',
      toastCompleted: 'Ziyaret başarıyla tamamlandı!',
      introText: 'Takvimi okumak · Yeni vizit açmak · Vizit formunu doldurup tamamlamak',
      deadlineTitle: 'Tamamlama süresi',
      window: 'Vizit penceresi',
      lastDay: 'Pencerenin son günü',
      grace: '+72 saat',
      canComplete: 'Tamamlayabilirsiniz',
      locked: 'Salt okunur',
      endTitle: 'Hazırsınız!',
      endText: 'Takvim sekmesinde bu video her zaman yanınızda.',
    },
  },
  cv: {
    types: {
      'CV-TR': {
        name: 'Türkçe CV',
        upload: 'Türkçe CV Yükle',
        list: 'Türkçe CV dosyam',
        description: 'Türkçe CV’nizi PDF, DOC veya DOCX olarak yükleyin. Bakanlık başvurularında Bakanlık Özgeçmiş Formu kullanılır.',
        empty: 'Henüz Türkçe CV yüklenmedi',
      },
      'CV-EN': {
        name: 'İngilizce CV',
        upload: 'İngilizce CV Yükle',
        list: 'İngilizce CV dosyam',
        description: 'İngilizce CV’nizi PDF, DOC veya DOCX olarak yükleyin. Sponsorlar çoğunlukla TransCelerate formatını ister.',
        empty: 'Henüz İngilizce CV yüklenmedi',
      },
      GCP: {
        name: 'GCP',
        upload: 'GCP Yükle',
        list: 'GCP belgem',
        description: 'GCP sertifikanızı PDF, DOC veya DOCX olarak yükleyin. Yenilediğinizde eskisini silip yenisini yükleyin.',
        empty: 'Henüz GCP belgesi yüklenmedi',
      },
      IATA: {
        name: 'IATA',
        upload: 'IATA Yükle',
        list: 'IATA belgelerim',
        description: 'IATA sertifikalarınızı PDF, DOC veya DOCX olarak yükleyin. Birden fazla dosyayı tek seferde seçebilirsiniz.',
        empty: 'Henüz IATA belgesi yüklenmedi',
      },
    },
    count_one: '{{count}} belge',
    count_other: '{{count}} belge',
    uploaded: 'Yüklü',
    loading: 'Belgeler yükleniyor...',
    emptyText: 'Dosyanızı yükleme alanından seçip yükleyin; burada listelenir.',
    actions: {
      view: 'Görüntüle',
      download: 'İndir',
      delete: 'Sil',
    },
    rules: {
      maxSize: 'En fazla 10 MB',
      formats: 'PDF, DOC veya DOCX',
      multiple: 'Birden fazla dosya seçilebilir',
      single: 'Tek dosya',
    },
    templateTr: 'Bakanlık Özgeçmiş Formu şablonunu indir',
    templateEn: 'TransCelerate CV şablonunu indir',
    templateHint: 'Şablonu doldurup aşağıdan yükleyebilirsiniz.',
    locked: '{{type}} belgeniz zaten yüklü. Yeni dosya yüklemek için önce mevcut dosyayı silin.',
    drop: 'Dosya seçin veya buraya sürükleyin',
    dropNow: 'Dosyayı bırakın',
    dropHint: 'PDF, DOC veya DOCX · en fazla 10 MB',
    selectedCount_one: '{{count}} dosya seçildi',
    selectedCount_other: '{{count}} dosya seçildi',
    remove: 'Kaldır',
    removeAll: 'Tümünü kaldır',
    uploading: 'Yükleniyor...',
    confirmDelete: {
      title: 'Belge silinsin mi?',
      message: '“{{name}}” silinecek. Bu işlem geri alınamaz.',
      confirm: 'Evet, sil',
    },
    toast: {
      loadError: 'Belgeler yüklenirken hata oluştu.',
      badType: '{{name}}: Yalnızca PDF, DOC veya DOCX dosyaları yüklenebilir.',
      tooLarge: '{{name}}: Dosya boyutu 10 MB’tan küçük olmalıdır.',
      onlyOne: 'Yalnızca bir dosya seçebilirsiniz; ilk dosya seçildi.',
      chooseFile: 'Lütfen bir dosya seçin.',
      exists: '{{type}} için zaten bir dosya var. Yeni dosya yüklemek için önce mevcut dosyayı silin.',
      uploaded_one: '{{type}} belgesi yüklendi.',
      uploaded_other: '{{count}} adet {{type}} belgesi yüklendi.',
      uploadError: '{{type}} yüklenirken bir hata oluştu: {{message}}',
      deleted: '{{type}} belgesi silindi.',
      deleteError: '{{type}} silinirken hata oluştu.',
    },
  },
  quiz: {
    title: 'Okuma Sonu Değerlendirme',
    loading: 'Sorular hazırlanıyor...',
    loadError: 'Sorular yüklenemedi. Lütfen tekrar deneyin.',
    questionOf: 'Soru {{current}} / {{total}}',
    passScore: 'Geçme notu %{{score}}',
    choices: 'Şıklar',
    previous: 'Önceki',
    next: 'Sonraki',
    finish: 'Sınavı Bitir',
    percent: '%{{value}}',
    correctOf: '{{correct}} / {{total}} doğru',
    passed: 'Başarılı',
    failHint: 'Doğru cevaplar, aynı soru yeniden çıkabileceği için gösterilmez. Dokümanı tekrar gözden geçirip yeni sorularla deneyebilirsiniz.',
    correctAnswer: 'Doğru cevap: {{answer}}',
    complete: 'Tamamla',
    backToDocument: 'Dokümana Dön',
    retry: 'Yeni Sorularla Tekrar Dene',
  },
  education: {
    title: 'Eğitim',
    duration: '{{minutes}} dk {{seconds}} sn',
    percent: '%{{value}}',
    play: 'Oynat',
    pause: 'Duraklat',
    back10: '10 saniye geri',
    forward10: '10 saniye ileri',
    mute: 'Sesi kapat',
    unmute: 'Sesi aç',
    volume: 'Ses düzeyi',
    fullscreen: 'Tam ekran',
    exitFullscreen: 'Tam ekrandan çık',
    videoError: 'Video yüklenemedi. Lütfen daha sonra tekrar deneyin.',
    notVideo: 'Bu SOP video biçiminde değil. Dokümanı açmak için aşağıdaki düğmeyi kullanın.',
    viewDocument: 'Dokümanı Görüntüle',
    currentSection: 'Şu anki bölüm',
    learningProgress: 'Öğrenme ilerlemesi',
    tabsLabel: 'Eğitim paneli',
    tabs: {
      content: 'İçerik',
      notes: 'Notlar',
      bookmarks: 'Yer imleri',
    },
    sections: {
      introduction: 'Giriş',
      coreConcepts: 'Temel kavramlar',
      practice: 'Uygulama',
      summary: 'Özet',
    },
    quizPromptTitle: 'Bilgi sınavı',
    quizPromptText: 'Eğitimin %80’inden fazlasını izlediniz. Eğitimi tamamlamak için kısa bir sınava girin.',
    startQuiz: 'Sınava Başla',
    takeQuizToComplete: 'Tamamlamak İçin Sınava Gir',
    markCompleted: 'Tamamlandı Olarak İşaretle',
    certificateTitle: 'Sertifikanızı kazandınız!',
    certificateText: 'Bu eğitimi başarıyla tamamladınız. Aşağıdan “Tamamlandı olarak işaretle”ye basabilirsiniz.',
    notesTitle: 'Notlarım',
    notesHint: 'Alandan çıkınca kaydedilir',
    notesPlaceholder: 'İzlerken not alın...',
    saveNotes: 'Notları Kaydet',
    bookmarksTitle: 'Yer imlerim',
    addBookmark: 'Yer imi ekle',
    addBookmarkShort: 'Ekle',
    goTo: 'Git',
    noBookmarks: 'Henüz yer imi yok. Önemli anlara hızla dönmek için videoda yer imi ekleyin.',
    watchedBadge: '%{{value}} tamamlandı',
    expiredTitle: 'Süre doldu',
    expiredText: 'Bu eğitimin son katılma tarihi geçti.',
    expiredDeadline: 'Son katılma tarihi: {{date}}',
    showChapters: 'Bölümleri göster',
    hideChapters: 'Bölümleri gizle',
    contents: 'İçerik',
    noChapters: 'Bu eğitimde bölüm tanımlanmamış.',
    watched: 'İzlenen',
    loadingProgress: 'İlerlemeniz yükleniyor...',
    popQuizTitle: 'Pop Quiz',
    popQuizSubtitle: 'Devam etmek için bu soruyu doğru cevaplayın',
    choices: 'Şıklar',
    submitAnswer: 'Cevabı Gönder',
    continue: 'Devam Et',
    rewatch: 'Bölümü Tekrar İzle',
    finalQuiz: 'Final sınavı',
    finalDone: 'Tamamlandı · %{{score}}',
    finalLocked: 'Sınav, videonun %95’i izlenince açılır.',
    startExam: 'Sınava Başla',
    passScore: 'Geçme puanı %{{score}}',
    questionOf: 'Soru {{current}} / {{total}}',
    previous: 'Önceki',
    next: 'Sonraki',
    finishExam: 'Sınavı Bitir',
    congrats: 'Tebrikler!',
    sorry: 'Maalesef',
    scoreLabel: 'Başarı puanı',
    passedText: 'Sınavı başarıyla geçtiniz ve sertifikanızı kazandınız!',
    failedText: 'Geçmek için en az %{{score}} puan almanız gerekiyor. Videoyu tekrar izleyip yeniden deneyebilirsiniz.',
    viewCertificate: 'Sertifikayı Görüntüle',
    completeEducation: 'Eğitimi Tamamla',
    rewatchVideo: 'Videoyu Tekrar İzle',
    retake: 'Tekrar Dene',
    certificateModalTitle: 'Sertifika',
    certificateHeading: 'Başarı Sertifikası',
    certificateIntro: 'Bu sertifika',
    participant: 'Katılımcı',
    certificateOf: 'adlı katılımcının',
    certificateScore: 'eğitimini %{{score}} başarı puanıyla tamamladığını onaylar.',
    certificateDate: 'Tarih: {{date}}',
    qualityManagement: 'Kalite Yönetimi',
    toast: {
      bookmarkAdded: 'Yer imi eklendi.',
      notesSaved: 'Notlar kaydedildi.',
      resumed: 'Kaldığınız yerden devam ediliyor: {{time}}',
      noSkip: 'Henüz izlemediğiniz bölümlere atlayamazsınız.',
      chapterLocked: 'Bu bölümü izleyebilmek için önceki bölümleri tamamlamalısınız.',
      wrongAnswer: 'Yanlış cevap! Lütfen bu bölümü tekrar izleyin.',
      certificate: 'Tebrikler! Sertifikanızı kazandınız!',
    },
  },
  messenger: {
    search: 'Kişi ara...',
    today: 'Bugün',
    yesterday: 'Dün',
    historyNotLoaded: 'Sohbet geçmişiniz henüz yüklenmedi.',
    loadHistory: 'Sohbet Geçmişini Yükle',
    conversations: 'Sohbetler',
    allUsers: 'Tüm kişiler',
    noUsers: 'Kişi bulunamadı.',
    pickTitle: 'Bir sohbet seçin',
    pickText: 'Soldaki listeden bir kişiye dokunarak yazışmaya başlayın; dosya gönderebilir, sesli veya görüntülü arayabilirsiniz.',
    typingShort: 'yazıyor...',
    typing: '{{name}} yazıyor',
    someone: 'Kişi',
    showPhoto: 'Profil fotoğrafını göster',
    voiceCall: 'Sesli ara',
    videoCall: 'Görüntülü ara',
    emptyChat: '{{name}} ile henüz mesajınız yok. İlk mesajı siz yazın.',
    callEnded: '{{name}} ile görüşme bitti',
    voiceInvite: '{{name}} sizi sesli görüşmeye davet ediyor',
    videoInvite: '{{name}} sizi görüntülü görüşmeye davet ediyor',
    joinCall: 'Katıl',
    removeFile: 'Dosyayı kaldır',
    attach: 'Dosya ekle',
    placeholder: 'Mesaj yazın...',
    send: 'Gönder',
    conference: {
      active: 'Aktif toplantı',
      host: 'Başlatan: {{name}}',
      join: 'Katıl',
      end: 'Bitir',
      start: 'Toplantı Başlat',
      starting: 'Başlatılıyor...',
      pickSomeone: 'Lütfen en az bir katılımcı seçin.',
      title: 'Toplantı Katılımcıları',
      subtitle: 'Toplantıyı yalnızca seçtiğiniz kişiler görür',
      search: 'Çalışan ara...',
      selectAll: 'Tümünü seç',
      deselectAll: 'Tümünü kaldır',
      selected_one: '{{count}} kişi seçildi',
      selected_other: '{{count}} kişi seçildi',
      startWith: 'Toplantıyı Başlat ({{count}})',
    },
    broadcast: {
      open: 'Toplu Mesaj Gönder',
      title: 'Toplu Mesaj Gönder',
      recipients_one: '{{count}} kişiye gönderilecek',
      recipients_other: '{{count}} kişiye gönderilecek',
      info: 'Mesaj herkese ayrı ayrı gönderilir; her kişi mesajı kendi sohbetinde görür.',
      placeholder: 'Mesajınızı yazın...',
      removeFile: 'Dosyayı kaldır',
      attach: 'Dosya Ekle',
      sendAll: 'Herkese Gönder',
      sending: 'Gönderiliyor...',
      sentTitle: 'Mesaj gönderildi!',
      sentText_one: 'Toplu mesajınız {{count}} kişiye iletildi.',
      sentText_other: 'Toplu mesajınız {{count}} kişiye iletildi.',
      history: 'Gönderilen toplu mesajlar ({{count}})',
      people_one: '{{count}} kişi',
      people_other: '{{count}} kişi',
      confirmDelete: 'Bu mesaj {{count}} kişinin sohbetinden silinecek. Emin misiniz?',
      delete: 'Evet, sil',
      deleting: 'Siliniyor...',
      deleteHint: 'Bu toplu mesajı sil',
    },
  },
  projectVisits: {
    title: 'Proje Visitleri',
    help: 'Tamamlanan bir visitin tüm ayrıntılarını "Detay" ile açabilirsiniz. Tarih aralığı seçerek listeyi daraltın; Excel dosyası görünen visitleri içerir.',
    total: 'Toplam Visit: {{count}}',
    completed_one: '{{count}} tamamlandı',
    completed_other: '{{count}} tamamlandı',
    ongoing_one: '{{count}} devam ediyor',
    ongoing_other: '{{count}} devam ediyor',
    excel: 'Excel İndir',
    close: 'Kapat',
    loading: 'Visitler yükleniyor',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    clearDates: 'Tarihleri temizle',
    columns: {
      date: 'Tarih',
      type: 'Visit Tipi',
      patient: 'Hasta ID',
      hospital: 'Hastane',
      city: 'Şehir',
      status: 'Durum',
      action: 'İşlem',
    },
    status: {
      done: 'Tamamlandı',
      ongoing: 'Devam Ediyor',
    },
    detail: 'Detay',
    detailDisabled: 'Visit devam ettiği için detaylar görüntülenemez',
    empty: 'Bu proje için hiç Visit bulunamadı',
    emptyHint: 'Bu projede açılmış bir visit olduğunda burada listelenir.',
    noMatch: 'Bu tarih aralığında visit yok',
    noMatchHint: 'Tarihleri değiştirin ya da temizleyin.',
    details: {
      title: 'Visit Detayları',
      excel: 'Tabloyu İndir',
      sections: {
        hospital: 'Hastane Visit Detayları',
        home: 'Home Visit Detayları',
        issues: 'Sorun & Düzeltme Takibi',
        basic: 'Temel Bilgiler',
        todo: 'Yapılacaklar Listesi',
        other: 'Diğer Bilgiler',
      },
      preVisit: 'Vizit öncesi',
      duringVisit: 'Vizit sırasında ve sonrasında',
      done: 'Yapıldı',
      notDone: 'Yapılmadı',
      todoCount: '{{done}} / {{total}} tamamlandı',
      fields: {
        projectName: 'Proje Adı',
        centerId: 'Merkez ID',
        visitId: 'Visit ID',
        visitType: 'Visit Tipi',
        siteCoordinator: 'Site Koordinatörü',
        patientId: 'Hasta ID',
        screenFail: 'Screen Fail?',
        dropPatient: 'Drop Patient?',
        visitDate: 'Visit Tarihi',
        visitStartTime: 'Visit Başlangıç Saati',
        protocolDeviation: 'Protokol Sapması',
        capaOpened: 'CAPA Açıldı mı?',
        comments: 'Yorumlar',
        ecrfDate: 'eCRF Tamamlanma Tarihi',
        ecrfTime: 'eCRF Tamamlanma Saati',
        sourceDocDate: 'Kaynak Dok. Tamamlanma Tarihi',
        sourceDocTime: 'Kaynak Dok. Tamamlanma Saati',
        signatureDate: 'İmza Tamamlanma Tarihi',
        signatureTime: 'İmza Tamamlanma Saati',
        processEndDate: 'Süreç Bitiş Tarihi',
        cycleTime: 'Döngü Süresi (gün)',
        issueOccurred: 'Sorun Oluştu mu?',
        slaTarget: 'SLA Hedefi (gün)',
        slaMet: 'SLA Karşılandı mı?',
        slaOverdue: 'SLA Gecikti mi?',
        protocolNo: 'Protokol No.',
        siteId: 'Site ID',
        windowOpen: 'Pencere Açılış Tarihi',
        targetDate: 'Hedef Tarih',
        windowClose: 'Pencere Kapanış Tarihi',
        subjectStatus: 'Hasta Durumu',
        visitStartDate: 'Visit Başlangıç Tarihi',
        visitEndDate: 'Visit Bitiş Tarihi',
        visitEndTime: 'Visit Bitiş Saati',
        durationHours: 'Visit Süresi - Saat',
        durationMinutes: 'Visit Süresi - Dakika',
        issueDuringVisit: 'Visit Sırasında Sorun Oluştu mu?',
        issueDeviation: 'Sorun Protokol Sapmasına Yol Açtı mı?',
        issueSource: 'Sorunun Kaynağı',
        smoCorrections: 'SMO Düzeltme Talepleri',
        qualityCheck: 'Kalite Yöneticisi Kontrolü',
        craRequest: 'CRA Talebi',
        correctionReason: 'Düzeltme Nedeni / Yorum',
        initialSource: 'İlk Kaynak Alınma Tarihi',
        latestRevision: 'CPM’den Son Revizyon Talebi Tarihi',
        sourceFinalized: 'Kaynak Kesinleşme Tarihi',
        capaTaken: 'Aksiyon / CAPA Alındı mı?',
        dcfCreated: 'DCF Oluşturuldu mu?',
        isClosed: 'Kapatıldı mı?',
        capaStart: 'Başlangıç Tarihi',
        capaClose: 'Kapanış Tarihi',
        targetAchieved: 'Hedefe Ulaşıldı mı?',
        severity: 'Şiddet Derecesi',
        date: 'Tarih',
        startTime: 'Başlangıç Saati',
        endTime: 'Bitiş Saati',
        doctor: 'Doktor',
        hospital: 'Hastane',
        city: 'Şehir',
        travelType: 'Seyahat Tipi',
        status: 'Durum',
        sourceDocument: 'Kaynak Döküman',
        sourceDocumentTime: 'Kaynak Döküman Tamamlanma Saati',
        information: 'Bilgi',
        createdAt: 'Oluşturulma Tarihi',
        lastUpdated: 'Son Güncelleme',
        completedAt: 'Tamamlanma Tarihi',
        firstVisitDate: 'İlk Visit Tarihi',
        employeeName: 'Çalışan Adı',
        selectedCra: 'Seçilen CRA',
        period: 'Periyot',
        option: 'Opsiyon',
      },
    },
  },
  agenda: {
    title: 'Ajandam',
    description: 'Google Takviminize hızlıca etkinlik ekleyin. Giriş yapmanız gerekmez: bilgiler dolu olarak Google Takvim açılır.',
    openCalendar: 'Google Takvimimi Aç',
    eventTitle: 'Etkinlik başlığı',
    eventTitlePlaceholder: 'Örn. Proje toplantısı',
    eventDescription: 'Açıklama',
    eventDescriptionPlaceholder: 'Etkinlikle ilgili notlar',
    start: 'Başlangıç tarihi ve saati',
    end: 'Bitiş tarihi ve saati',
    add: 'Google Takvime Ekle',
    opened: 'Google Takvim yeni sekmede açıldı. Etkinliği kaydetmek için oradaki "Kaydet" düğmesine basın.',
    howTo: 'Nasıl kullanılır?',
    steps: {
      fill: 'Etkinlik bilgilerini doldurun.',
      add: '"Google Takvime Ekle"ye basın.',
      save: 'Açılan Google Takvim sayfasında "Kaydet"e basın.',
      done: 'Etkinlik takviminize eklenir.',
    },
    note: 'Bu bölüm kayıt tutmaz; etkinlik doğrudan Google hesabınızdaki takvime eklenir.',
    errors: {
      title: 'Etkinlik başlığı gerekli.',
      start: 'Başlangıç tarihi ve saati gerekli.',
      end: 'Bitiş tarihi ve saati gerekli.',
      order: 'Bitiş, başlangıçtan sonra olmalı.',
      past: 'Başlangıç geçmişte olamaz.',
      url: 'Takvim bağlantısı oluşturulurken bir hata oluştu.',
    },
  },
  files: {
    title: 'Dosyalarım',
    description: 'Rolünüze atanmış SOP’ler, eğitimler, formlar, politikalar ve görev tanımları. Bir kategoriye dokunun, listesi aşağıda açılsın.',
    categories: {
      sop: {
        title: 'SOP Dosyaları',
        description: 'Standart operasyon prosedürleri',
      },
      education: {
        title: 'Eğitimler',
        description: 'Video eğitim ve gelişim içerikleri',
      },
      forms: {
        title: 'Formlar',
        description: 'Standart form ve belgeler',
      },
      policies: {
        title: 'Politikalar',
        description: 'Şirket politikaları',
      },
      jobDescriptions: {
        title: 'Görev Tanımları',
        description: 'Pozisyonunuzun görev tanımı',
      },
    },
    cards: {
      sopStat: '{{read}}/{{total}} okundu',
      educationStat: '{{done}}/{{total}} tamamlandı',
      count_one: '{{count}} doküman',
      count_other: '{{count}} doküman',
      new_one: '{{count}} yeni',
      new_other: '{{count}} yeni',
    },
    help: {
      sop: 'Bir SOP’yi açıp sonuna kadar okuyun, ardından "Okudum ve anladım" kutusunu işaretleyin. Kısa bir değerlendirme sınavı açılır; geçtiğinizde SOP "Okundu" olur.',
      education: 'Eğitimi izlemeye başlayın; videonun en az yarısını izlediğinizde tamamlanmış sayılır. Son katılım tarihi geçen eğitimler açılmaz.',
      forms: 'Forma dokunduğunuzda dosyası yeni sekmede açılır; oradan indirebilir veya yazdırabilirsiniz.',
    },
    sopFilter: {
      label: 'SOP filtresi',
      all: 'Tümü',
      unread_one: 'Okunmadı ({{count}})',
      unread_other: 'Okunmadı ({{count}})',
      read_one: 'Okundu ({{count}})',
      read_other: 'Okundu ({{count}})',
    },
    search: {
      sop: 'SOP ara...',
      education: 'Eğitim ara...',
      forms: 'Form ara...',
      policies: 'Politika ara...',
      jobDescriptions: 'Görev tanımı ara...',
    },
    empty: {
      sop: 'Size atanmış SOP bulunmuyor.',
      education: 'Size atanmış eğitim bulunmuyor.',
      forms: 'Erişebileceğiniz form bulunmuyor.',
      policies: 'Size atanmış politika bulunmuyor.',
      jobDescriptions: 'Size atanmış görev tanımı bulunmuyor.',
    },
    untitled: {
      policies: 'İsimsiz politika',
      jobDescriptions: 'İsimsiz görev tanımı',
    },
    noMatch: '"{{term}}" ile eşleşen sonuç bulunamadı.',
    loadError: 'Dokümanlar yüklenirken bir hata oluştu.',
    kinds: {
      pdf: 'PDF doküman',
      video: 'Video',
      ppt: 'Sunum',
      other: 'Dosya',
    },
    badges: {
      new: 'Yeni',
      read: 'Okundu',
      unread: 'Okunmadı',
      completed: 'Tamamlandı',
      expired: 'Süre doldu',
    },
    deadline: 'Son katılım: {{date}}',
    download: 'İndir',
    downloadNamed: '{{name}} indir',
    version: 'Versiyon {{version}}',
    noFile: 'Bu doküman için dosya bulunmuyor.',
    cannotPreview: 'Bu dosya türü burada görüntülenemiyor; lütfen indirerek açın.',
    viewer: {
      title: 'SOP doküman görüntüleyici',
      version: 'Versiyon {{version}}',
      openInTab: 'Yeni sekmede aç',
      noVideo: 'Tarayıcınız video oynatmayı desteklemiyor.',
      cannotPreview: 'Bu dosya türü burada görüntülenemiyor. İndirip okuduktan sonra onay verebilirsiniz.',
      download: 'Dosyayı indir',
      confirm: 'Bu SOP dokümanını okudum ve anladım',
      lockedHint: 'Onay kutusu, doküman yüklendikten birkaç saniye sonra (videoda izleme bitince) açılır. Lütfen dokümanı sonuna kadar okuyun.',
      quizHint: 'Onayladığınızda departmanınıza özel kısa bir değerlendirme sınavı açılır.',
      readHint: 'Bu SOP okundu olarak kayıtlı. Onayı geri almak için kutuya tekrar dokunabilirsiniz.',
    },
    toast: {
      markedRead: 'SOP okundu olarak işaretlendi.',
      markedUnread: 'SOP okunmadı olarak işaretlendi.',
      actionError: 'İşlem sırasında bir hata oluştu.',
      noFormFile: 'Bu form için dosya bulunmuyor.',
      trainingDone: 'Eğitim başarıyla tamamlandı!',
    },
  },
  projects: {
    title: 'Projelerim',
    description: 'Görev aldığınız projeler. Bir projeye dokunarak o projedeki vizitlerinizi görebilirsiniz.',
    hidePassive_one: 'Pasif projeyi gizle',
    hidePassive_other: 'Pasif projeleri gizle ({{count}})',
    showPassive_one: 'Pasif projeyi göster',
    showPassive_other: 'Pasif projeleri göster ({{count}})',
    primer: 'Primer',
    backup: 'Backup',
    blinded: 'Blinded',
    unblinded: 'Unblinded',
    missingInfo: 'Bilgi eksik',
    missingInfoHint: '"Bilgi eksik" görünen projelerde çalışan tipiniz (primer / backup) veya kör çalışma durumunuz girilmemiş. Proje yöneticinize bildirin.',
    passive: 'Pasif',
    passiveRole: 'Bu projedeki göreviniz pasif',
    passiveProject: 'Proje pasif durumda',
    empty: 'Atanmış projeniz bulunmuyor.',
    emptyHint: 'Bir projeye atandığınızda burada görünür.',
    allPassiveHidden: 'Tüm projeleriniz pasif ve gizli.',
  },
  leave: {
    types: {
      yillik: 'Yıllık İzin',
      mazeret: 'Mazeret İzni',
      raporlu: 'Raporlu',
      dogum_oncesi: 'Doğum Öncesi İzin',
      babalik: 'Babalık İzni',
      evlilik: 'Evlilik İzni',
      olum: 'Ölüm İzni',
      engelli_cocuk: 'Engelli Çocuk Mazeret İzni',
      dogum_sonrasi: 'Doğum Sonrası İzin',
      yatakli_tedavi: 'Yataklı Kurumda Tedavi',
      refakat: 'Refakat İzni',
      sua: 'Şua İzni',
      saglik_kurulu: 'Sağlık Kurulu Raporu',
      ayakta_tedavi: 'Ayakta Tedavi',
    },
    status: {
      PENDING: 'Beklemede',
      APPROVED: 'Onaylandı',
      REJECTED: 'Reddedildi',
    },
    toast: {
      loadError: 'İzin talepleri yüklenirken bir hata oluştu.',
    },
    form: {
      title: 'İzin Talep Et',
      description: 'Talebiniz yöneticinizin onayına gider; durumunu "İzin Taleplerim"den takip edebilirsiniz.',
      type: 'İzin türü',
      typeHints: {
        yillik: 'Yıllık izin bakiyenizden düşer',
        mazeret: 'Kısa süreli kişisel mazeretler',
        raporlu: 'Sağlık raporu ile; raporu ekleyebilirsiniz',
      },
      balance: {
        entitlement: 'Toplam hak',
        used: 'Kullanılan',
        reserved: 'Onay bekleyen',
        remaining: 'Kalan',
      },
      noBalance: 'Kullanılabilir yıllık izin hakkınız bulunmuyor; yeni yıllık izin talebi gönderemezsiniz.',
      start: 'Başlangıç tarihi',
      end: 'Bitiş tarihi',
      endHint: 'İznin son günü',
      days: 'İzin süresi (gün)',
      daysHint: 'Tarihlerden hesaplanır: cumartesi yarım gün, pazar ve resmi tatiller sayılmaz.',
      travelDays: 'Yol süresi (gün)',
      travelDaysHint: 'Varsa; yarım gün girebilirsiniz (0,5)',
      overBalance: 'Talep ettiğiniz süre ({{requested}} gün) kalan bakiyenizden ({{remaining}} gün) fazla.',
      reason: 'İzin nedeni',
      reasonPlaceholder: 'Kısaca açıklayın',
      address: 'İzinde bulunacağınız adres',
      addressPlaceholder: 'Şehir / adres',
      addressHint: 'Gerekirse size ulaşabilmek için',
      report: 'Rapor dosyası',
      reportHint: 'İsteğe bağlı · PDF, JPG, PNG, DOC',
      chooseReport: 'Dosya seç',
      removeReport: 'Dosyayı kaldır',
      approvalNote: 'Gönderdikten sonra talebiniz "Beklemede" görünür; onaylanınca takviminize de işlenir.',
      submit: 'İzin Talebini Gönder',
      sending: 'Gönderiliyor...',
      sent: 'İzin talebiniz gönderildi. Yöneticiniz tarafından değerlendirilecek.',
      errors: {
        dates: 'Lütfen başlangıç ve bitiş tarihlerini girin.',
        user: 'Kullanıcı bilgileriniz bulunamadı.',
        days: 'Geçerli bir izin süresi seçin.',
        balance: 'Yetersiz yıllık izin bakiyesi. Kalan: {{remaining}} gün, talep edilen: {{requested}} gün.',
        send: 'İzin talebi gönderilirken bir hata oluştu. Lütfen tekrar deneyin.',
      },
    },
    list: {
      title: 'İzin Taleplerim',
      description: 'Gönderdiğiniz izin talepleri ve yöneticinizin girdiği izinler. Durumunu ve yönetici notunu buradan görebilirsiniz.',
      newRequest: 'Yeni Talep',
      filterLabel: 'Duruma göre filtrele',
      all: 'Tümü',
      empty: 'Henüz izin talebiniz yok.',
      emptyHint: 'İzin talep etmek için "Yeni Talep"e dokunun.',
      noMatch: 'Bu durumda izin talebi yok.',
      sentOn: '{{date}} tarihinde gönderildi',
      unknownDate: 'Tarih bilinmiyor',
      sourceRequest: 'İzin talebi',
      sourceAdmin: 'Yönetici tarafından girildi',
      start: 'Başlangıç',
      end: 'Bitiş',
      days: 'Süre',
      travelDays: 'Yol süresi',
      dayCount_one: '{{count}} gün',
      dayCount_other: '{{count}} gün',
      reason: 'İzin nedeni',
      address: 'Adres',
      report: 'Rapor dosyası',
      adminNote: 'Yönetici notu',
      createdByAdmin: 'Bu izin yöneticiniz tarafından girildi.',
      notReviewed: 'Henüz değerlendirilmedi',
      reviewedBy: 'Değerlendiren: {{name}}',
    },
  },
  expense: {
    categories: {
      transport: 'Ulaşım',
      food: 'Yemek',
      accommodation: 'Konaklama',
      supplies: 'Malzeme',
      training: 'Eğitim',
      other: 'Diğer',
    },
    status: {
      pending: 'Bekliyor',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
    },
    form: {
      title: 'Masraf Talep Et',
      description: 'Yaptığınız harcamayı belgeleriyle birlikte iletin; finans yöneticilerinin onayına gider.',
      amount: 'Tutar (₺)',
      category: 'Kategori',
      descriptionLabel: 'Açıklama',
      descriptionPlaceholder: 'Ne için, nerede, ne zaman harcandı?',
      documents: 'Belgeler (PDF)',
      documentsHint: 'İsteğe bağlı · fiş ve faturaları PDF olarak ekleyin',
      approvalNote: 'Talebiniz finans yöneticilerine görev ve e-posta olarak iletilir. Onaylanana kadar "Masraf Takip"ten düzenleyebilirsiniz.',
      submit: 'Masraf Talebini Gönder',
      sending: 'Gönderiliyor...',
      uploading: 'PDF yükleniyor...',
      successTitle: 'Masraf talebiniz iletildi',
      successText: 'Talebiniz oluşturuldu ve onay için finans yöneticilerine iletildi. Durumunu "Masraf Takip"ten izleyebilirsiniz.',
      goTracking: 'Masraf Takip’e git',
      newRequest: 'Yeni Talep Oluştur',
      errors: {
        amountRequired: 'Tutar zorunludur',
        amountPositive: 'Tutar 0’dan büyük olmalıdır',
        descriptionRequired: 'Açıklama zorunludur',
        required: 'Lütfen zorunlu alanları doldurun.',
        user: 'Kullanıcı bilgileriniz bulunamadı.',
        upload: 'PDF yüklenirken bir hata oluştu.',
        uploadDetail: 'PDF yüklenirken bir hata oluştu: {{message}}',
        send: 'Masraf talebi gönderilirken bir hata oluştu: {{message}}',
      },
    },
    pdf: {
      choose: 'PDF dosyalarını seçin',
      limits: 'Birden fazla dosya seçebilirsiniz · her biri en fazla 10 MB',
      selected_one: 'PDF dosyası seçildi.',
      selected_other: '{{count}} PDF dosyası seçildi.',
      selectedTitle_one: 'Seçilen dosya',
      selectedTitle_other: 'Seçilen dosyalar ({{count}})',
      removeAll: 'Tümünü kaldır',
      allRemoved: 'Tüm dosyalar kaldırıldı.',
      removed: 'Dosya kaldırıldı.',
      removeOne: '{{name}} dosyasını kaldır',
      notPdf: '{{name}}: yalnızca PDF dosyaları yüklenebilir.',
      tooLarge: '{{name}}: dosya 10 MB’tan küçük olmalı.',
    },
    tracking: {
      title: 'Masraf Taleplerim',
      description: 'Gönderdiğiniz masraf talepleri ve durumları. Bekleyen talepleri düzenleyebilirsiniz.',
      newRequest: 'Yeni Talep',
      total: 'Toplam',
      all: 'Tümü',
      filterLabel: 'Duruma göre filtrele',
      empty: 'Henüz masraf talebiniz yok.',
      emptyHint: '"Masraf Talep Et"ten yeni bir talep oluşturabilirsiniz.',
      noMatch: 'Bu durumda masraf talebi yok.',
      edit: 'Düzenle',
      pendingHint: 'Onay bekliyor',
      rejectionReason: 'Reddedilme nedeni',
      processedOn: 'İşlem tarihi: {{date}}',
      documentN: 'Belge {{n}}',
    },
    approvals: {
      help: 'Bekleyen talepleri belgeleriyle birlikte inceleyin; uygunsa onaylayın, değilse nedenini yazarak reddedin. Neden çalışana iletilir.',
      helpOwn: 'Gönderdiğiniz masraf talepleri. Henüz işlem görmemiş bir talebi silebilirsiniz.',
      titleAll: 'Tüm Masraf Talepleri',
      titleOwn: 'Masraf Taleplerim',
      count_one: '{{count}} talep',
      count_other: '{{count}} talep',
      refresh: 'Yenile',
      search: 'Çalışan, kategori veya açıklama ara...',
      loading: 'Masraf talepleri yükleniyor',
      stats: {
        label: 'Talep özeti ve hızlı filtre',
        all: 'Toplam',
        pending: 'Bekleyen',
        approved: 'Onaylanan',
        rejected: 'Reddedilen',
        pendingAmount: 'Onay Bekleyen Tutar',
        pendingAmountShort: 'Bekleyen ₺',
      },
      empty: 'Henüz masraf talebi bulunmuyor',
      emptyHint: 'Çalışanlar "Masraf Talep Et" sekmesinden talep oluşturduğunda burada listelenir.',
      emptyOwnHint: 'Masraf talebi oluşturmak için "Masraf Talep Et" sekmesini kullanabilirsiniz.',
      noMatch: 'Eşleşen masraf talebi yok',
      noMatchHint: 'Arama ifadesini veya filtreyi değiştirmeyi deneyin.',
      clearFilters: 'Filtreyi temizle',
      noDate: 'Tarih yok',
      approve: 'Onayla',
      reject: 'Reddet',
      delete: 'Sil',
      documents: 'Belgeler ({{count}})',
      documentN: 'Belge {{n}}',
      view: '{{name}} belgesini görüntüle',
      download: '{{name}} belgesini indir',
      rejectionReason: 'Reddedilme nedeni',
      readReason: 'Tamamını gör',
      editReason: 'Nedeni düzenle',
      processedOn: 'İşlem tarihi: {{date}}',
      reasonDialog: {
        title: 'Reddedilme Nedeni',
        close: 'Kapat',
      },
      editDialog: {
        title: 'Reddedilme Nedenini Düzenle',
        text: 'Reddedilme nedenini güncelleyin; çalışan talebinde güncel nedeni görür.',
        label: 'Reddedilme Nedeni',
        placeholder: 'Reddedilme nedenini buraya yazın...',
        cancel: 'İptal',
        save: 'Kaydet',
      },
      rejectDialog: {
        title: 'Masraf Talebini Reddet',
        text: 'Lütfen masraf talebini neden reddettiğinizi açıklayın. Bu bilgi çalışana iletilecektir.',
        label: 'Reddedilme Nedeni',
        placeholder: 'Örn: Dekont eksik, tutar hatalı, onaysız harcama...',
        cancel: 'İptal',
        confirm: 'Reddet',
      },
      deleteDialog: {
        title: 'Masraf talebi silinsin mi?',
        message: 'Bu masraf talebini silmek istediğinizden emin misiniz?',
        confirm: 'Evet, sil',
        cancel: 'Vazgeç',
      },
      toast: {
        loadError: 'Masraf talepleri yüklenirken bir hata oluştu.',
        deleted: 'Masraf talebi silindi!',
        deleteError: 'Masraf talebi silinirken bir hata oluştu: {{message}}',
        noPermission: 'Bu işlem için yetkiniz bulunmamaktadır.',
        approved: 'Masraf talebi onaylandı!',
        statusError: 'Durum güncellenirken bir hata oluştu: {{message}}',
        reasonRequired: 'Lütfen reddedilme nedenini giriniz.',
        rejected: 'Masraf talebi reddedildi!',
        pdfMissing: 'PDF dosyası bulunamadı',
        reasonUpdated: 'Reddedilme nedeni güncellendi!',
        updateError: 'Güncelleme sırasında bir hata oluştu: {{message}}',
      },
    },
    edit: {
      title: 'Masraf Talebini Düzenle',
      subtitle: 'Onaylanmadan önce değişiklik yapabilirsiniz',
      existing: 'Ekli belgeler',
      removeExisting: 'Belgeleri kaldır',
      existingRemoved: 'Ekli belgeler kaldırılacak.',
      view: 'Görüntüle',
      download: 'İndir',
      downloading: 'PDF indiriliyor...',
      documentN: 'Belge {{n}}',
      replace: 'Belgeleri değiştir',
      replaceHint: 'Yeni PDF seçerseniz ekli belgelerin yerini alır.',
      add: 'PDF belgesi ekle',
      saving: 'Kaydediliyor...',
      saved: 'Masraf talebi güncellendi.',
      saveError: 'Masraf güncellenirken bir hata oluştu: {{message}}',
    },
  },
  messages: {
    title: 'Mesajlar',
    description: 'Çalışma arkadaşlarınızla yazışın, dosya paylaşın ve görüşme başlatın.',
    unread_one: '{{count}} okunmamış mesajınız var',
    unread_other: '{{count}} okunmamış mesajınız var',
    load: 'Mesajları Aç',
    loading: 'Mesajlar yükleniyor...',
  },
  notifications: {
    title: 'Bildirimler',
    description: 'Şirket genelindeki duyurular. Yeni duyurular en üstte görünür.',
    empty: 'Şu an duyuru yok.',
    emptyHint: 'Yeni bir duyuru yayınlandığında burada görünür.',
    delete: 'Sil',
    deleteTitle: 'Duyuru silinsin mi?',
    deleteMessage: 'Bu duyuru herkes için kaldırılacak. Bu işlem geri alınamaz.',
    admin: {
      pinTitle: 'Yeni duyuru',
      pinHint: 'Herkesin Bildirimler bölümünde görünür.',
      pinPlaceholder: 'Duyuru metni...',
      pinSubmit: 'Duyuruyu Yayınla',
      broadcastTitle: 'Toplu mesaj',
      broadcastHint: 'Yönetici olmayan tüm çalışanların mesaj kutusuna sistem mesajı olarak gider.',
      broadcastPlaceholder: 'Tüm çalışanlara gidecek mesaj...',
      broadcastSubmit: 'Toplu Mesaj Gönder',
      broadcastConfirmTitle: 'Toplu mesaj gönderilsin mi?',
      broadcastConfirm: 'Bu mesaj, yöneticiler hariç tüm çalışanların mesaj kutusuna gönderilecek.',
    },
    toast: {
      pinned: 'Duyuru yayınlandı.',
      pinError: 'Duyuru yayınlanırken bir hata oluştu.',
      broadcastSent_one: 'Toplu mesaj 1 kişiye gönderildi.',
      broadcastSent_other: 'Toplu mesaj {{count}} kişiye gönderildi.',
      broadcastError: 'Mesaj gönderilirken bir hata oluştu: {{message}}',
      deleted: 'Duyuru silindi.',
      deleteError: 'Duyuru silinirken bir hata oluştu.',
    },
  },
  errorReport: {
    title: 'Hata Bildir',
    description: 'Portalda karşılaştığınız bir hatayı yazılım ekibine iletin.',
    tips: 'Ne yapmaya çalışırken, hangi sayfada ve ne olduğunu yazın. Bir ekran görüntüsü sorunu çok daha hızlı çözmemizi sağlar.',
    summary: 'Hatanın açıklaması',
    summaryPlaceholder: 'Örn. Takvimde vizit eklerken "Kaydet"e basınca sayfa yanıt vermiyor...',
    required: 'Lütfen hatanın açıklamasını yazın.',
    screenshot: 'Ekran görüntüsü',
    screenshotHint: 'İsteğe bağlı',
    chooseScreenshot: 'Görüntü seç',
    removeScreenshot: 'Görüntüyü kaldır',
    submit: 'Bildirimi Gönder',
    sending: 'Gönderiliyor...',
    sent: 'Hata bildiriminiz iletildi. Teşekkürler!',
    sendError: 'Hata bildirimi gönderilemedi.',
  },
  complaints: {
    types: {
      sikayet: 'Şikayet Dilekçesi',
      talep: 'Talep Dilekçesi',
      itiraz: 'İtiraz Dilekçesi',
      mobbing: 'Mobbing Bildirimi',
      cinsel_taciz: 'Cinsel Taciz Bildirimi',
      sozlu_taciz: 'Sözlü Taciz Bildirimi',
      fiziksel_taciz: 'Fiziksel Taciz Bildirimi',
      psikolojik_siddet: 'Psikolojik Şiddet Bildirimi',
      ayrimcilik: 'Ayrımcılık Bildirimi',
      is_guvenligi: 'İş Güvenliği İhlali Bildirimi',
      etik_ihlali: 'Etik İhlal Bildirimi',
      oneri: 'Öneri Dilekçesi',
      diger: 'Diğer',
    },
    status: {
      PENDING: 'Beklemede',
      INCELENIYOR: 'İnceleniyor',
      RESOLVED: 'Çözüldü',
      CLOSED: 'Kapatıldı',
    },
    to: 'Muhatap: {{names}}',
    replies_one: 'Yetkili yanıtı (1)',
    replies_other: 'Yetkili yanıtları ({{count}})',
    downloadDocx: 'Dilekçeyi indir (DOCX)',
    openDetail: '{{subject}} dilekçesini aç',
    toast: {
      historyError: 'Dilekçe geçmişi yüklenirken bir hata oluştu.',
      incomingError: 'Gelen dilekçeler yüklenirken bir hata oluştu.',
    },
    form: {
      title: 'Dilekçe Yaz',
      description: 'Resmi bir dilekçe oluşturun; seçtiğiniz yetkililere iletilir ve bir kopyası belge (DOCX) olarak saklanır.',
      heading: 'DİLEKÇE',
      subheading: 'Resmi başvuru formu',
      targets: 'Kime gönderilecek',
      authority: 'Yetkili',
      testMode: 'Test modu',
      sender: 'Başvuru sahibi',
      name: 'Ad soyad',
      email: 'E-posta',
      title2: 'Unvan',
      department: 'Departman',
      loading: 'Yükleniyor...',
      type: 'Dilekçe türü',
      typePlaceholder: 'Dilekçe türünü seçin',
      subject: 'Konu',
      subjectPlaceholder: 'Dilekçenizin konusu',
      details: 'Dilekçe metni',
      greeting: 'Sayın İlgili,',
      detailsPlaceholder: 'Başvurunuzun ayrıntılarını açık ve net biçimde yazın...',
      closing1: 'Gereğini bilgilerinize arz ederim.',
      closing2: 'Saygılarımla,',
      privacy: 'Dilekçeniz gizlilikle değerlendirilir ve yalnızca yetkili kişiler tarafından incelenir.',
      submit: 'Dilekçeyi Gönder',
      sending: 'Gönderiliyor...',
      sent: 'Dilekçeniz gönderildi.',
      errors: {
        session: 'Oturum hatası. Lütfen sayfayı yenileyin.',
        type: 'Lütfen bir dilekçe türü seçin.',
        content: 'Lütfen konu ve dilekçe metnini doldurun.',
        target: 'Lütfen en az bir muhatap seçin.',
        send: 'Dilekçe gönderilirken bir hata oluştu: {{message}}',
      },
    },
    history: {
      title: 'Geçmiş dilekçelerim',
      description: 'Gönderdiğiniz dilekçelerin durumu ve yetkililerin yanıtları.',
      empty: 'Henüz bir dilekçeniz yok.',
    },
    incoming: {
      title: 'Gelen Dilekçeler',
      descriptionAdmin: 'Sisteme gelen tüm dilekçeler. Bir dilekçeye dokunarak durumunu değiştirebilir ve yanıt yazabilirsiniz.',
      descriptionTarget: 'Size iletilen dilekçeler. Bir dilekçeye dokunarak durumunu değiştirebilir ve yanıt yazabilirsiniz.',
      filterLabel: 'Duruma göre filtrele',
      all: 'Tümü',
      search: 'Konu, kişi veya numara ara...',
      empty: 'Henüz gelen dilekçe yok.',
      noMatch: 'Bu filtreyle eşleşen dilekçe yok.',
      detailTitle: 'Dilekçe ayrıntısı',
      sender: 'Gönderen',
      date: 'Tarih',
      type: 'Tür',
      currentStatus: 'Mevcut durum',
      targets: 'Muhatap',
      details: 'Dilekçe metni',
      changeStatus: 'Durumu değiştir',
      current: 'Mevcut',
      statusUpdated: 'Dilekçe durumu güncellendi.',
      statusError: 'Dilekçe durumu güncellenirken bir hata oluştu.',
      writeReply: 'Yanıt yaz',
      replyPlaceholder: 'Dilekçe sahibine iletilecek yanıtınız...',
      replyRequired: 'Lütfen bir yanıt yazın.',
      sendReply: 'Yanıtı Gönder',
      sending: 'Gönderiliyor...',
      replySent: 'Yanıtınız gönderildi.',
      replyError: 'Yanıt gönderilirken bir hata oluştu.',
    },
  },
};

export default profilePage;
